module.exports = __webpack_public_path__ + "img/om.d33345fb.svg";